import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterTuksom extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterSunday2'>
      <div><Link to='/'>Home</Link></div>
      <h3>Aikido Tuksom's Members</h3>
      <br />
      <br />

      <div><Link to='/conduct-chatchawane'>1. AAT  5483 MR.CHATCHAWAN EGAWARIN(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-borwonr'>2. AAT  5471  MR.BORWON ROCHANAPON(A)</Link></div>
      <br />
      <div><Link to='/conduct-choosakp'>3. AAT  6893 MR.CHOOSAK PHUMUEANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-nattasuth'>4. AAT  7014  MR.NATTASUT HATTAGRUM(A)</Link></div>
      <br />
      <div><Link to='/conduct-thanaip'>5. AAT  2024  COL.THANAI PERMPUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-thakhunk'>6. AAT  6514  MR.NATTAPONG KAEWISARAPRAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-jacquesp'>7. AAT  7369  MR.JACQUES DU PLESSIS(A)</Link></div>
      <br />
      <div><Link to='/conduct-wannatouchp'>8. AAT  7847  MR.WANNATOUCH PRASERT(A)</Link></div>
      <br />
      <div><Link to='/conduct-namont'>9. AAT  7888  MS.NAMON THATTIYAPHONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-pattarananp'>10. AAT  6894  MS.PATTARANAN PHUMUEANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-anantayak'>11. AAT  7749  MS.ANANTAYA KULTANAKORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-thanyapatp'>12. AAT  7299  MS.THANYAPHAT PHUMUEANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-chanchita'>13. AAT  7870  MR.CHANCHIT APISAMAJAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-manussaporne'>14. AAT  7942  MS.MANUSSAPORN  EKVISIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-sirawichu'>15. AAT  8015  MR.SIRAWICH  UDOMKANA(A)</Link></div>
      <br />
      <div><Link to='/conduct-pats'>16. AAT  8016  MR.PAT SUTHAPUNNAKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-kittipatw'>17. AAT  8001  MR.KITTIPAT  WIRIYA(A)</Link></div>
      <br />
      <div><Link to='/conduct-orawanp'>18. AAT  8014  MS.ORAWAN PONGPRUEKSAPATTANA(A)</Link></div>
      <br />
      <div><Link to='/conduct-chanmethap'>19. AAT  8054  MR.CHANMETHA PERMPUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-piroontipl'>20. AAT  8097  MS.PIROONTIP LAKKHANAWIROT(A)</Link></div>
      <br />
      <div><Link to='/conduct-jaruwann'>21. AAT  8104  MS.JARUWAN NUMPHA(A)</Link></div>
      <br />
      <div><Link to='/conduct-krittitatw'>22. AAT  8112  MR.KRITTITAT WANSU(A)</Link></div>
      <br />
      <div><Link to='/conduct-siwathornr'>23. AAT  5995  MR.SIWATHORN RATICHOTKAWIN(A)</Link></div>
      <br />
      <div><Link to='/conduct-tirawana'>24. AAT  7390  MS.TIRAWAN AREERAS(A)</Link></div>
      <br />
      <div><Link to='/conduct-jeerawita'>25. AAT  7391  MR.JEERAWIT AREERAS(A)</Link></div>
      <br />
      <div><Link to='/conduct-loonweewatt'>26. AAT  7848  MR.LOONWEEWAT TAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-poonkanuto'>27. AAT  7918  MS.POONKANUT  OMARAK(A)</Link></div>
      <br />
      <div><Link to='/conduct-sengdaviengd'>28. AAT  8000  MS.SENGDAVIENG DOUANGPANYA(A)</Link></div>
      <br />





        <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterTuksom;
